// @ts-expect-error tinymce not fully typed
import tinymce from 'tinymce';
import { FLINT } from 'HubStyleTokens/colors';
import { INLINE_TARGET_FORMAT_CONFIG } from 'tinymce-plugins/constants/inlineTarget';
const svgElements = 'svg[*],defs[*],pattern[*],desc[*],metadata[*],g[*],mask[*],path[*],line[*],marker[*],rect[*],circle[*],ellipse[*],polygon[*],polyline[*],linearGradient[*],radialGradient[*],stop[*],image[*],view[*],text[*],textPath[*],title[*],tspan[*],glyph[*],symbol[*],switch[*],use[*]';
const iframeAttrs = ['id', 'accesskey', 'class', 'dir', 'lang', 'style', 'tabindex', 'title', 'role', 'allow', 'contenteditable', 'contextmenu', 'draggable', 'dropzone', 'hidden', 'spellcheck', 'translate', 'xml:lang', 'src', 'name', 'width', 'height', 'longdesc', 'frameborder', 'marginwidth', 'marginheight', 'scrolling', 'align', 'sandbox', 'seamless', 'allowfullscreen', 'loading'];
const iframeSchema = `iframe[${iframeAttrs.join('|')}]`;
const blockContent = 'address|figure|blockquote|div|dl|fieldset|form|h1|h2|h3|h4|h5|h6|hr|menu|ol|p|pre|table|ul';
const removeformat = [{
  selector: 'b,strong,em,i,font,u,strike,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins',
  remove: 'all',
  split: true,
  expand: false,
  block_expand: true,
  deep: true
}, {
  selector: 'span',
  attributes: ['style', 'class'],
  remove: 'empty',
  split: true,
  expand: false,
  deep: true
}, {
  selector: '*',
  attributes: ['style', 'class'],
  split: false,
  expand: false,
  deep: true
}, {
  selector: 'img',
  attributes: ['align'],
  remove: 'empty',
  split: false,
  expand: false,
  deep: false
}, {
  selector: '.mce-token',
  styles: {
    margin: 'auto',
    'margin-left': 'auto',
    'margin-right': 'auto'
  },
  remove: 'none',
  split: false,
  expand: false,
  deep: false
}];
const persistentStyles = ['background-color', 'text-align', 'text-decoration', 'font-style', 'font-weight', 'vertical-align', 'margin-left', 'margin', 'border', 'border-style', 'border-color', 'color', 'font-size'].join(' ');
export const settings = {
  mode: 'exact',
  preview_styles: false,
  browser_spellcheck: true,
  // Default URL settings
  convert_urls: false,
  relative_urls: false,
  remove_script_host: false,
  // don't allow script tags in content
  allow_script_urls: false,
  //  this can be used to disable our tweaks to the image plugin to use the file manager
  withoutFileManager: false,
  // media (video) plugin options
  media_alt_source: false,
  media_poster: false,
  // new in 4.3
  media_live_embeds: false,
  // contextmenu plugin options
  contextmenu: 'link image inserttable | cell row column deletetable',
  // Allow text to be at the document root,
  // but force paragraphs on carriage return
  forced_root_block: false,
  force_p_newlines: Boolean(tinymce.majorVersion === '4'),
  // allow any attribute on common layout tags
  extended_valid_elements: `#p[*],a[*],span[*],img[*],div[*],button[*],section[*],i[*],blockquote[*],address[*],blockquotespan[*],script[*],video[*],table[*],${iframeSchema},${svgElements}`,
  valid_children: `+a[${blockContent}}]`,
  custom_elements: '~svg',
  statusbar: false,
  table_toolbar: false,
  allow_html_in_named_anchor: true,
  formats: {
    removeformat,
    hsInlineTarget: INLINE_TARGET_FORMAT_CONFIG
  },
  // Prevent tinyMCE from breaking IE/Outlook conditional comments
  // by inserting a space before the [if ...]
  protect: [/<!--\[.*?\]>[\s\S]*?(-->|<!\[.*?\]-->)/g, /<!--[\s]*?<!\[.*\]-->/g],
  table_default_attributes: {
    border: '0'
  },
  // keep specific styles of pasted content
  paste_retain_style_properties: persistentStyles,
  paste_webkit_styles: persistentStyles
};
export const getPasteDefaultTableStyles = () => ({
  'border-color': FLINT,
  'border-collapse': 'collapse',
  'table-layout': 'fixed',
  'margin-left': 'auto',
  'margin-right': 'auto',
  'border-width': '1px',
  'border-style': 'solid'
});